"use client";
import { usePathname } from "@/i18n/navigation";
import CombineWord from "./CombineWord/CombineWord";
import WordCounter from "./WordCounter/WordCounter";
import TextReverse from "./TextReverse/TextReverse";
import SplitText from "./SplitText/SplitText";
import TruncateText from "./TruncateText/TruncateText";
import UrlDecode from "./UrlDecode/UrlDecode";
import UrlEncode from "./UrlEncode/UrlEncode";
import RemoveSpace from "./RemoveSpace/RemoveSpace";
import TextCompare from "./TextCompare/TextCompare";
import FancyFont from "./FancyFont/FancyFont";
import TextToSpeech from "./TextToSpeech/TextToSpeech";
import SpeechToText from "./SpeechToText/SpeechToText";
import TextCaseInverter from "./TextCaseInverter/TextCaseInverter";
import TextToPdf from "./TextToPdf/TextToPdf";
import ToLowerCase from "./LowerCase/ToLowerCase";
import MDFiveGenerator from "./Md5/MDFiveGenerator";
import ToUpperCase from "./Uppercase/ToUpperCase";
import { ParaData } from "../common/CommonArray/FileArray";
import { HowToUseText } from "@/common/ToolPara";
import JSONViewer from "./JsonViewer/JSONViewer";

const routeConfig = {
  "/combine-the-word": {
    toolName: "Combine The Word Convertor",
    paraData: ParaData.COMBINE_WORD,
  },
  "/lowercase-to-uppercase": {
    toolName: "Lowercase to Uppercase Converter",
    paraData: ParaData.LOWER_UPPER,
  },
  "/uppercase-to-lowercase": {
    toolName: "Uppercase to Lowercase Converter",
    paraData: ParaData.UPPER_LOWER,
  },
  "/word-counter": {
    toolName: "Word Counter Convertor",
    paraData: ParaData.WORD_COUNTER,
  },
  "/md5-generator": {
    toolName: "MD5 Generator Convertor",
    paraData: ParaData.MD_GENERATOR,
  },
  "/text-reverser": {
    toolName: "Text Reverser",
    paraData: ParaData.TEXT_REVERSE,
  },
  "/split-text": {
    toolName: "Split Text",
    paraData: ParaData.SPLIT_TEXT,
  },
  "/truncate-text": {
    toolName: "Truncate Text",
    paraData: ParaData.TRUNCATE_TEXT,
  },
  "/url-encode": {
    toolName: "URL Encoder",
    paraData: ParaData.URL_ENCODE,
  },
  "/url-decode": {
    toolName: "URL Decoder",
    paraData: ParaData.URL_ENCODE,
  },
  "/remove-all-white-spaces": {
    toolName: "Remove All White Spaces",
    paraData: ParaData.REMOVE_WHITE_SPACES,
  },
  "/text-compare": {
    toolName: "Text Compare",
    paraData: ParaData.TEXT_COMPARE,
  },
  "/fancy-font": {
    toolName: "Fancy Font Generator",
    paraData: ParaData.FANCY_FONT,
  },
  "/text-to-speech": {
    toolName: "Text to Speech",
    paraData: ParaData.TEXT_TO_SPEECH,
  },
  "/speech-to-text": {
    toolName: "Speech to Text",
    paraData: ParaData.SPEECH_TO_TEXT,
  },
  "/text-case-inverter": {
    toolName: "Text Case Inverter",
    paraData: ParaData.TEXT_CASE_INVERTER,
  },
  "/text-to-pdf": {
    toolName: "Text to PDF Converter",
    paraData: ParaData.TEXT_TO_PDF,
  },
  "/json-lens": {
    toolName: "JSON Viewer",
    paraData: ParaData.JSON_VIEWER,
  },
};
function TextArea() {
  const pathname = usePathname();
  const currentRoute = routeConfig[pathname];
  return (
    <>
      {pathname === "/combine-the-word" && <CombineWord />}
      {pathname === "/json-lens" && <JSONViewer />}
      {pathname === "/lowercase-to-uppercase" && <ToUpperCase />}
      {pathname === "/uppercase-to-lowercase" && <ToLowerCase />}
      {pathname === "/word-counter" && <WordCounter />}
      {pathname === "/md5-generator" && <MDFiveGenerator />}
      {pathname === "/text-reverser" && <TextReverse />}
      {pathname === "/split-text" && <SplitText />}
      {pathname === "/truncate-text" && <TruncateText />}
      {pathname === "/url-encode" && <UrlEncode />}
      {pathname === "/url-decode" && <UrlDecode />}
      {pathname === "/remove-all-white-spaces" && <RemoveSpace />}
      {pathname === "/text-compare" && <TextCompare />}
      {pathname === "/fancy-font" && <FancyFont />}
      {pathname === "/text-to-speech" && <TextToSpeech />}
      {pathname === "/speech-to-text" && <SpeechToText />}
      {pathname === "/text-case-inverter" && <TextCaseInverter />}
      {pathname === "/text-to-pdf" && <TextToPdf />}
      {currentRoute && (
        <HowToUseText
          toolName={currentRoute.toolName}
          firstPata={currentRoute.paraData.firstPara}
          secondPara={currentRoute.paraData.secondPara}
          toolData={currentRoute.paraData.toolData}
          howToUse={currentRoute.paraData.howToUse}
          whyUse={currentRoute.paraData.whyUse}
          commonUseCases={currentRoute.paraData.commonUseCases}
          features={currentRoute.paraData.features}
          faq={currentRoute.paraData.faq}
          tips={currentRoute.paraData.tips}
          relatedTools={currentRoute.paraData.relatedTools}
        />
      )}
    </>
  );
}

export default TextArea;
